<template>
    <main-layout :loading="loading">
        <template #header>
            <main-header :title="'매뉴얼 관리'" backable></main-header>
        </template>

        <template #toolbar>
            <template v-if="manual">
                <v-btn color="error" v-if="manual.status === 'ACTIVE'" @click.stop="onClickClose">비활성화</v-btn>
                <v-btn color="primary" v-else-if="(manual.status === 'NEW' || manual.status === 'CLOSED')"
                       :disabled="items.length === 0" @click.stop="onClickActivate">활성화
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="dirties.length === 0 && removes.length === 0" @click="updateAll" :loading="loadingUpdate">저장
                </v-btn>
            </template>
        </template>

        <template #body>
            <v-card class="fill-height" outlined style="background-color: #f8f8f8;">
                <div class="fill-height overflow-hidden"
                     style="display: flex; flex-direction: column; justify-content: stretch;">
                    <!--                    <manage-item-edit-form-tool-box></manage-item-edit-form-tool-box>-->
                    <div class="overflow-hidden"
                         style="display: flex; flex-direction: row; justify-content: stretch; flex-grow: 1;">
                        <div class="overflow-y-auto"
                             style="flex-grow: 1; border-right: 1px solid #ddd; justify-content: stretch;">
                            <v-list dense>
                                <v-subheader>{{ $route.query.title }} [{{ name }}]
                                    <v-spacer></v-spacer>
                                    <v-tooltip top color="success">
                                        <template v-slot:activator="{on}">
                                            <v-btn
                                                    v-on="on"
                                                    @click.stop="onCickAddManualItem"
                                                    icon
                                                    color="success">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <div style="max-width: 300px;">새로운 매뉴얼 항목 생성</div>
                                    </v-tooltip>
                                </v-subheader>
                                <v-list-item-group
                                        v-model="model"
                                        color="primary"
                                        mandatory>
                                    <draggable :list="items" class="dragArea"
                                               :options="{animation:300, handle:'.handle'}"
                                               @change="onChangeSequence"
                                    >
                                        <v-list-item
                                                v-for="(item, index) in items"
                                                :key="index"
                                                class="text-left handle">
                                            <v-list-item-content>
                                                <v-list-item-title style="overflow-y: visible; overflow-x: hidden;">
                                                    <div style="display: flex; align-items: center; padding-right: 50px; overflow-y: visible;">
                                                        <div style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis;">
                                                            {{ item.title }}
                                                        </div>
                                                        <v-spacer></v-spacer>
                                                        <div class="mr-3">
                                                            <template
                                                                    v-if="item.status === 'NEW' || item.status === 'CLOSED'">
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn icon @click.stop.prevent="activate(item)"
                                                                               v-on="on">
                                                                            <v-icon color="success">mdi-progress-check
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    활성화하기
                                                                </v-tooltip>
                                                            </template>
                                                            <template v-if="item.status === 'ACTIVE'">
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn icon @click.stop.prevent="close(item)"
                                                                               v-on="on">
                                                                            <v-icon>mdi-progress-check
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    비활성화하기
                                                                </v-tooltip>
                                                            </template>
                                                        </div>
                                                        <template v-if="item.status === 'NEW'">
                                                            <v-badge color="yellow accent-4" icon="mdi-exclamation"
                                                                     class="mt-3"></v-badge>
                                                        </template>
                                                        <template v-else-if="item.status === 'CLOSED'">
                                                            <v-badge color="red accent-4" icon="mdi-close"
                                                                     class="mt-3"></v-badge>
                                                        </template>
                                                    </div>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </draggable>
                                </v-list-item-group>
                            </v-list>
                        </div>
                        <!-- 컨텐츠 영역은 항상 같은 width를 유지합니다. -->
                        <v-card
                                class="overflow-y-auto"
                                style="overflow-x: visible; min-width: 1100px; display: flex; justify-content: stretch; align-items: start; flex-direction: column; background-color: #f8f8f8;"
                        >
                            <div style="width: 885px; background-color: white;">
                                <div class="section-hidden">
                                    <div class="section-add" @click="onClickAddSection(0)">
                                        <v-icon>mdi-plus</v-icon>
                                        여기에 섹션 추가
                                    </div>
                                </div>
                                <div v-for="(manualItem, index) in items"
                                     :key="manualItem.id">
                                    <manual-item-edit-form
                                            :manual-item="manualItem"
                                            :is-selected="index === model"
                                            @focus="model = index"
                                            @blur="onBlurEditForm(index)"
                                    >
                                    </manual-item-edit-form>
                                    <div class="section-hidden">
                                        <div class="section-add" @click="onClickAddSection(index + 1)">
                                            <v-icon>mdi-plus</v-icon>
                                            여기에 섹션 추가
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
            </v-card>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainHeader from "@/components/common/layout/MainHeader";
    import {PATH} from "@/constants";
    import ManualItemEditForm from "@/views/manual/item/ManualItemEditForm";

    export default {
        name: "ManualItemManage",
        components: {ManualItemEditForm, MainHeader, MainLayout},
        props: {
            name: undefined,
        },
        data() {
            return {
                model: null,
                items: [],
                requestBody: {
                    title: "",
                    content: "",
                },
                editorOption: {},
                manual: undefined,
                loading: false,
                loadingItems: false,
                newTitle: "",
                dirties: [],
                removes: [],
                mark: [],
                loadingUpdate: false,
                markSelected: null,
            };
        },
        computed: {
            /**
             * 현재 선택된 항목
             */
            selected() {
                if (this.$isNOU(this.model)) return null;
                return this.items[this.model];
            },
        },
        watch: {
            /**
             * deep 핸들러에서는 oldValue title 과 content 가 newValue 랑 동일합니다.
             *
             * 그래서 deep handler 가 실행되기 이전에 이전 값을 저장해둡니다.
             */
            'selected.title'(newValue, oldValue) {
                if (!this.markSelected) return; // 초기 로드시 로직 실행 방지
                if (this.selected !== this.markSelected) return; // 선택된 모델 변경시 로직 실행 방지
                this.addDirty();
            },
            'selected.content'(newValue, oldValue) {
                if (!this.markSelected) return; // 초기 로드시 로직 실행 방지
                if (this.selected !== this.markSelected) return;// 선택된 모델 변경시 로직 실행 방지
                this.addDirty();
            },
            selected(newValue, oldValue) {
                this.markSelected = newValue;
            },
        },
        beforeDestroy() {
            // 컴포넌트가 제거될 때 모든 항목을 업데이트합니다.
            this.updateAll();
        },
        created() {
            this.loadManual();
            this.loadManualItems();
            setInterval(this.updateAll, 1000 * 10 /* 10초마다 저장합니다.*/);
        },
        methods: {
            async loadManual() {
                if (this.loading) return;
                this.loading = true;
                const res = await this.$request(PATH.MANUAL.DETAIL)
                    .setObject({name: this.name})
                    .enqueue();
                this.manual = res;
                this.loading = false;
            },

            async loadManualItems() {
                if (this.loadingItems) return;
                this.loadingItems = true;
                const res = await this.$request(PATH.MANUAL_ITEM.LIST)
                    .setObject({nameLink: this.name})
                    .enqueue();
                this.items = res.data;
                this.loadingItems = false;
            },

            /**
             * 매뉴얼 항목을 추가합니다.
             */
            async onCickAddManualItem() {
                this.onClickAddSection(this.items.length);
            },

            /**
             * 새로운 섹션을 추가합니다.
             */
            onClickAddSection(index) {
                const before = this.items.slice(0, index) || [];
                const after = this.items.slice(index, this.items.length) || [];
                this.items = before.concat([{title: "", content: "",}]).concat(after);
                // AutoFocus
                this.$nextTick(() => {
                    this.model = index;
                });
            },

            /**
             * EditForm 에서 blur 가 발생하였을 때 title 과 content 가 빈 문자열이면 해당 폼을 제거합니다.
             */
            onBlurEditForm(index) {
                if (!this.items[index].title.trim()
                    && !this.utilManager.stripHtml(this.items[index].content).trim()) {
                    const dirtyIndex = this.dirties.indexOf(this.items[index]);
                    if (dirtyIndex >= 0) this.dirties.splice(dirtyIndex, 1);
                    const removed = this.items.splice(index, 1);
                    if (removed[0] && (removed[0].id > 0)) {
                        this.removes.push(removed[0]);
                    }
                }
            },

            /**
             * 변경항목을 배열에 담습니다.
             */
            addDirty() {
                if (this.dirties.find(e => e === this.selected)) return;
                if (!this.selected.title.trim() && !this.utilManager.stripHtml(this.selected.content.trim())) return;
                this.dirties.push(this.selected);
            },

            /**
             * 매뉴얼 항목 추가 요청을 서버로 보냅니다.
             */
            async requestAddManualItem(data) {
                try {
                    const id = await this.$request(PATH.MANUAL_ITEM.CREATE)
                        .setObject({
                            nameLink: this.name,
                            title: data.title,
                            content: data.content,
                        })
                        .catch()
                        .enqueue()
                    data.id = id;
                    let i = 1;

                    // 현재 화면에 노출된 순서대로 다시 저장합니다.
                    const sequences = this.items.map(e => {
                        return {id: e.id, sequence: i++};
                    });

                    await this.$request(PATH.MANUAL_ITEM.SEQUENCE)
                        .setObject({
                            sequences: sequences,
                        })
                        .enqueue();
                    data.id = id; // 아이디만 추가해줍니다.
                    data.status = 'NEW';
                } catch (e) {
                    console.error(e);
                    this.$alert(e.response.data.hri || 'Unknown Error');
                }
            },

            /**
             * 매뉴얼 항목을 수정합니다.
             */
            async requestUpdateManualItem(serverData) {
                await this.$request(PATH.MANUAL_ITEM.UPDATE)
                    .setObject(serverData)
                    .enqueue();
            },

            /**
             * 매뉴얼 항목을 삭제합니다.
             */
            async requestDeleteManualItem(serverData) {
                await this.$request(PATH.MANUAL_ITEM.DELETE)
                    .setObject(serverData)
                    .enqueue();
            },

            /**
             * 모든 항목을 업데이트합니다.
             */
            async updateAll() {
                this.loadingUpdate = true;
                this.dirties.forEach(async e => {
                    if (e.id) { // 기존 항목 업데이트
                        await this.requestUpdateManualItem(e);
                    } else { // 새로운 섹션 서버 추가 요청
                        await this.requestAddManualItem(e);
                    }
                });
                this.dirties = [];
                this.removes.forEach(async e => {
                    if (e.id) { // 삭제 요청
                        await this.requestDeleteManualItem(e);
                    }
                });
                this.removes = [];
                this.loadingUpdate = false;
            },

            /**
             * 현재 화면에 노출된 순서대로 sequence 배열을 생성하여 서버로 업데이트 요청을 보냅니다.
             */
            async updateSequence() {
                let i = 1;

                // 현재 화면에 노출된 순서대로 다시 저장합니다.
                const sequences = this.items.map(e => {
                    return {id: e.id, sequence: i++};
                });

                await this.$request(PATH.MANUAL_ITEM.SEQUENCE)
                    .setObject({
                        sequences: sequences,
                    })
                    .enqueue();
            },

            /**
             * 매뉴얼 항목의 순서가 변경되었습니다.
             */
            onChangeSequence() {
                this.updateSequence();
            },

            /**
             * 해당 매뉴얼을 활성화 시킵니다.
             */
            onClickActivate() {
                if (!this.manual) return;
                this.$confirm('매뉴얼을 활성화합니다.<br><b>활성화된 매뉴얼은 사용자에게 노출되어집니다.<br>모든 부모 노드가 활성화됩니다.</b><br>활성화 하시겠습니까?')
                    .then(() => this.requestActivate());
            },

            /**
             * 활성화 요청을 서버로 보냅니다.
             */
            requestActivate() {
                if (!this.manual) return;
                this.$requestWithOverlay(PATH.MANUAL.ACTIVATE)
                    .setObject({id: this.manual.id})
                    .enqueue()
                    .then(() => this.manual.status = "ACTIVE");
            },

            /**
             * 해당 매뉴얼을 활성화 시킵니다.
             */
            onClickClose() {
                if (!this.manual) return;
                this.$confirm('<span style="color: red;">매뉴얼을 비활성화합니다.</span><br><b>비활성화된 매뉴얼은 사용자가 접근할 수 없습니다.<br>' +
                    '모든 <span style="color: red;">자식 노드</span>가 비활성화됩니다.</b><br>비활성화 하시겠습니까?')
                    .then(() => this.requestClose());
            },

            /**
             * 활성화 요청을 서버로 보냅니다.
             */
            requestClose() {
                if (!this.manual) return;
                this.$requestWithOverlay(PATH.MANUAL.CLOSE)
                    .setObject({id: this.manual.id})
                    .enqueue()
                    .then(() => this.manual.status = "CLOSED");
            },

            async activate(item) {
                await this.$request(PATH.MANUAL_ITEM.ACTIVATE)
                    .setObject({id: item.id})
                    .enqueue()
                    .then(e => {
                        item.status = 'ACTIVE';
                    });
            },

            async close(item) {
                await this.$request(PATH.MANUAL_ITEM.CLOSE)
                    .setObject({id: item.id})
                    .enqueue()
                    .then(e => {
                        item.status = 'CLOSED';
                    });
            },

        }
    }
</script>

<style scoped>
    >>> .ql-container {
        background-color: white;
    }

    .handle {
    }

    .section-add {
        visibility: hidden;
        font-weight: bold;
        text-align: left;
        padding-left: 16px;
        height: 30px;
        cursor: pointer;
        background-color: white;
        transition: .3s all;
    }

    .section-hidden:hover .section-add {
        visibility: visible;
        background-color: rgba(124, 45, 54, .5);
    }
</style>